import { useCallback } from 'react'
import { Linking } from 'react-native'

import { useQueryClient } from '@tanstack/react-query'
import { useNavigation } from '@zet/common/hooks/useNavigation'
import { useBrandDetailsById } from '@zet/feature-brands/api/brands/hooks'
import { IEligibleCustomerCard } from '@zet/feature-brands/api/brands/types'
import useBrandStore from '@zet/feature-brands/store/brands'
import { useUserContext } from '@zet/feature-user'
import { getName } from '@zet/utils/stringConversion'

const useEligibleCustomer = ({
  customerData,
  source,
  brandId,
  brandCategory,
  brandName,
  shareClickEventPayload,
  routeName,
}: IEligibleCustomerCard) => {
  const { data: user } = useUserContext()
  const queryClient = useQueryClient()
  const navigation = useNavigation()
  const { setLeadSource } = useBrandStore((state) => state)
  const { data: content } = useBrandDetailsById(brandId || '')

  const eventPayload = shareClickEventPayload || {
    item_name: source,
    source: source,
    user_id: user?.id,
    user_name: user?.name,
    customer_id: customerData?.customerId,
    customer_name: customerData?.fullName,
    customer_number: customerData?.phoneNumber,
    partner_id: brandId,
    brand_name: brandName,
    brand_category: brandCategory,
  }

  const handlePress = useCallback(() => {
    const navigationObject = {
      brandId: brandId,
      customerName: getName(customerData?.fullName),
      customerId: customerData?.customerId,
      customerPhoneNumber: customerData?.phoneNumber,
      eventName: 'click_action',
      eventPayload: shareClickEventPayload || eventPayload,
    }

    queryClient.invalidateQueries({
      queryKey: [`shareLink-${brandId}`],
    })
    queryClient.invalidateQueries({
      queryKey: [`globalShareLink-${brandId}`],
    })

    const shareButtonMessage = {
      en: content?.highGuaranteedContent?.shareButtonContent?.en,
      hi: content?.highGuaranteedContent?.shareButtonContent?.hi,
    }
    if (routeName === 'GuaranteedCustomerList') {
      setLeadSource('guaranteed')
      navigation.navigate('ShareCardLink', {
        ...navigationObject,
        shareButtonMessage,
      })
    } else {
      setLeadSource('eligibleBrand')
      navigation.replace('ShareCardLink', navigationObject)
    }
  }, [])

  const handleCallPress = () =>
    Linking.openURL(`tel:${customerData?.phoneNumber}`)

  return { eventPayload, handlePress, handleCallPress }
}

export default useEligibleCustomer
